import React from 'react';

import './SuccessMessage.global.scss';

interface Props {
    message: string
}

const SuccessMessage = (props: Props) => {
  const { message } = props;
  return (
    <>
      <p className="successMessage">{message}</p>
    </>
  );
};

export default SuccessMessage;
